import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 6l-8 4l8 4l8 -4l-8 -4","key":"svg-0"}],["path",{"d":"M4 14l8 4l8 -4","key":"svg-1"}]]

const IconStack = createReactComponent('outline', 'stack', 'Stack', __iconNode);

export default IconStack;